import React, {useContext, Component} from 'react';
import Nav from '../Nav/index';
import CoreCategory from './core-category';
import './progress.scss';
import CommsImgFilled from "../../assets/images/Happily-Ever-After-Icons-Communication.png";
import CommsImgEmpty from '../../assets/images/Happily-Ever-After-Icons-Communication-Gray.png';
import ConflictImgFilled from '../../assets/images/Happily-Ever-After-Icons-Conflict.png';
import ConflictImgEmpty from '../../assets/images/Happily-Ever-After-Icons-Conflict-Gray.png';
import SelfImgFilled from '../../assets/images/Happily-Ever-After-Icons-Self-Discovery.png';
import SelfImgEmpty from '../../assets/images/Happily-Ever-After-Icons-Self-Discovery-Gray.png';
import SexImgFilled from '../../assets/images/Happily-Ever-After-Icons-Intimacy-and-Sex.png';
import SexImgEmpty from '../../assets/images/Happily-Ever-After-Icons-Heart-Gray.png';
import MoneyImgFilled from '../../assets/images/Happily-Ever-After-Icons-Money.png';
import MoneyImgEmpty from '../../assets/images/Happily-Ever-After-Icons-Money-FGray.png';
import OriginImgFilled from '../../assets/images/Happily-Ever-After-Icons-Family-of-Origin.png';
import OriginImgEmpty from '../../assets/images/Happily-Ever-After-Icons-Family-of-Origin-Gray.png';
import withAuth from "../../services/withAuth";
import AuthService from "../../services/authService";
import CTour from '../Tour'
import {TourContext} from "../../contexts/TourContext";


// const CategoryPage = ({...props}) => {
    class CategoryPage extends Component{
        constructor(props){
            super(props);

            this.state = {
                showMenu: false,
            }
            // const {state} = useContext(TourContext);
            this.context = React.createContext(TourContext);
            this.categoryList = [];
            this.categoryArray = [
        {
            title: 'Communication',
            imgFilled: CommsImgFilled,
            imgEmpty: CommsImgEmpty,
        },
        {
            title: 'Conflict and Repair',
            imgFilled: ConflictImgFilled,
            imgEmpty: ConflictImgEmpty
        },
        {
            title: 'Money',
            imgFilled: MoneyImgFilled,
            imgEmpty: MoneyImgEmpty,
        },
        {
            title: 'Sex and Intimacy',
            imgFilled: SexImgFilled,
            imgEmpty: SexImgEmpty,
        },
        {
            title: 'Family of Origin',
            imgFilled: OriginImgFilled,
            imgEmpty: OriginImgEmpty,
        },
        {
            title: 'Self-Discovery',
            imgFilled: SelfImgFilled,
            imgEmpty: SelfImgEmpty,
        }];
    }

    // create core categories off sorted list in response
    createCategoryList(resp){
        resp = JSON.parse(resp)
        let finalList = [];
        let categoryId = resp.category_order;
        // Make an array of category ids
        let order = categoryId.map(x => x.category_id);
        let progress = resp.progress;
        // loop through progress and return objects with an id equal to the current order number
        for (let index = 0; index < order.length; index++) {
            // Use order to generate CoreCategory Components
            let currentId = order[index];
            let topic = progress.filter(function (x) {
                return x.category_id === currentId;
            });
            let {watched, reviewed, learned} = topic[0];
            // if any are true use the filled image for the category
            let icon = watched && reviewed && learned ? this.categoryArray[topic[0].category_id - 1].imgFilled : this.categoryArray[topic[0].category_id - 1].imgEmpty;
            let nextCategory = {
                coreCategoryTitle: this.categoryArray[topic[0].category_id - 1].title,
                categoryId: topic[0].category_id,
                heartWatched: watched,
                heartReviewed: reviewed,
                heartLearned: learned,
                iconsTitle: this.categoryArray[topic[0].category_id - 1],
                icon: icon,
                pulseTitle: this.context.pulseTitle,
                key: Math.random() * 100,

            };
            finalList.push(nextCategory);
        }
        // this.setState({
        //     categoryList: finalList
        // });
        this.categoryList = finalList
    }
    //init
    componentDidMount(){
        this.createCategoryList(AuthService.getUser());
        this.rerenderPage();
        window.scrollTo(0, 0);
    }

    rerenderPage(){
        if(this.state.showMenu === true){
            return;
        } else {
            this.setState({
                showMenu: false,
            })
        }

    }
    // console.log(state)

    createComp(){
        let t = [];
        this.categoryList.forEach((e, i) => {
            t.push(<CoreCategory
                coreCategoryTitle={e.coreCategoryTitle}
                categoryId={e.categoryId}
                heartWatched={e.heartWatched}
                heartReviewed={e.heartReviewed}
                heartLearned={e.heartLearned}
                icon={e.icon}
                iconsTitle={e.iconsTitle}
                index={i}
                key={Math.random() * 100}
                pulseTitle={i === 0 ? this.context.pulseTitle : false}
                {...this.props}/>)
        });
        return t;
    }

    handleClick = () => {
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleClose = (e) => {
        if(e === undefined){
            if(this.state.showMenu){
                this.setState({
                    showMenu: false
                })
            }
            return;
        }
        // console.log("close triggered" ,e.target);
        let target = e.target;

        if (target.classList.contains('large-text') || target.classList.contains('menu-list') || target.classList.contains('small-text') || target.classList.contains('social-icon') || target.classList.contains('menu-slideout') || target.classList.contains('menu-button')){
            return;
        }

        // if (target.classList.contains('close-menu')){
            if(this.state.showMenu){
                this.setState({
                    showMenu: false
                })
            }
        // }

    }

    render(){
        // console.log('rendered');

        return (

            <div id="progress-page" onClick={this.handleClose}>
                <Nav showMenu = {this.state.showMenu} handleClick = {this.handleClick} handleClose ={this.handleClose} />
                <h1>Progress</h1>
                <CTour/>
                <div id="core-category__container" data-tut="reactour__outer">
                    {this.createComp()}
                </div>

            </div>
        )
    }

}



export default withAuth(CategoryPage);
